import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { BasicAuthService } from '../../../../../services/basic-auth.service'
import { MenuTopSecondNotifyService } from './menu-top-second-notify.service'

@Component({
    selector: 'app-menu-top-second',
    templateUrl: './menu-top-second.component.html',
    standalone: false
})
export class MenuTopSecondComponent implements OnInit, OnDestroy {
  private readonly role: string
  private _subscription: Subscription
  private _items: { title: string; url: string; roles?: string[] }[] = []

  public get items(): { title: string; url: string; roles?: string[] }[] {
    return this._items
  }

  constructor(
    private basicAuthService: BasicAuthService,
    private notifyService: MenuTopSecondNotifyService,
  ) {
    this.role = this.basicAuthService.getUserRole()
  }

  public hasAccess(item: any): boolean {
    let roles: string[] = []
    if (item.roles && item.roles.length > 0) {
      roles = item.roles
      return roles.indexOf(this.role) !== -1
    }
    return true
  }

  ngOnInit(): void {
    this._subscription = this.notifyService.changeMenuEventEmitter.subscribe(
      (result: any[]) => {
        this._items = result
      },
      error => (this._items = []),
    )
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe()
  }
}
